<app-dialog-banner text="eMail Service Request to Suppliers" [dialogRef]="dialogRef"></app-dialog-banner>

<div style="padding: 2px 10px 0; min-width: 700px;" data-form-ready="true">
    <div style="display:flex; align-items:center; flex-wrap:wrap; padding-left:5px;">
        <span class="row-label">To:</span>
        @for (s of toSuppliers; track $index) {
            <ng-container [ngTemplateOutlet]="supplierChip" [ngTemplateOutletContext]="{s}"></ng-container>
        }
        <button (click)="addSupplier()" mat-icon-button color="primary" data-grid-new-supplier>
            <mat-icon>add_circle</mat-icon>
        </button>
    </div>
    <app-ctl-holder [control]="mailText.control"></app-ctl-holder>
    <div style="display:flex; align-items:flex-end; margin-top:-25px; padding-left:5px; padding-bottom:6px;">
        <div style="flex:1; display:flex; align-items:center;">
            <span class="row-label">Attach:</span>
            <app-mail-attachment-chips
                [availableAttachments]="sr.attachments"
                [(attachments)]="selectedAttachments">
            </app-mail-attachment-chips>
        </div>
        <div style="white-space:nowrap; padding-left:8px;">
            <button mat-button data-field-name="preview" [matTooltip]="previewTooltip" matTooltipPosition="above"
                [disabled]="actionsDisabled" (click)="doPreview()">
                Preview
            </button>
            <button mat-button data-field-name="attach" [matTooltip]="attachTooltip" matTooltipPosition="above"
                [disabled]="actionsDisabled" (click)="confirmAttach()">
                Attach
            </button>
            <button mat-button data-field-name="test" [matTooltip]="testTooltip" matTooltipPosition="above"
                [disabled]="actionsDisabled" (click)="confirmTest()">
                Test
            </button>
            <span [matTooltip]="hasEmailableSuppliers ? sendTooltip : 'Add at least one supplier with an email address'"
                matTooltipPosition="above">
                <button mat-raised-button color="primary" data-save-button
                    [disabled]="!hasEmailableSuppliers || actionsDisabled"
                    (click)="confirmSend()">
                    Send Emails
                </button>
            </span>
        </div>
    </div>
</div>

<ng-template #supplierChip let-s="s">
    <div class="chip">
        <p [matTooltip]="s.email">{{s.name}}</p>
        <mat-icon style="font-size:14px; height:14px; width:14px" color="warn"
            matTooltip="Delete" (click)="removeSupplier(s)">delete</mat-icon>
    </div>
</ng-template>
